import { useEffect, useState } from 'react'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { Href } from 'components/ui/Href/Href'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { AdriverEventType, EventType } from 'types/types'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { banners } from './data'
import { BannerItem } from './types'

import ArrowIcon from 'assets/img/shared/arrow2.svg?react'
import s from './Banner.module.scss'

export const Banner = () => {
  const { isTablet, isMobile } = useResize()

  const [currentIndex, setCurrentIndex] = useState<number>(0)

  const currentBanner = banners[currentIndex]
  const bannerImg = isMobile ? currentBanner.imgMobile : isTablet ? currentBanner.imgTablet : currentBanner.imgDesktop

  useEffect(() => {
    if (!isTablet && !isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length)
      }, 10000)

      return () => clearInterval(interval)
    }
  }, [isTablet, isMobile])

  useEffect(() => {
    if (!isMobile && !isTablet) {
      sendEvent(EventType.BannerS, { bid: currentBanner.id, name: currentBanner.name })
    }
  }, [currentBanner, isMobile, isTablet])

  const handleSlideChange = (swiper: any) => {
    setCurrentIndex(swiper.realIndex)
  }

  const handleClick = (banner: BannerItem) => {
    sendEvent(EventType.BannerT, { bid: banner.id, name: banner.name })
    sendAdriverEvent(AdriverEventType.findOutMore)
  }

  return (
    <section className={s.bannerWrapper}>
      {isTablet || isMobile ? (
        <>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            autoHeight={true}
            onSlideChange={handleSlideChange}
            className={s.swiper}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
          >
            {banners.map((banner) => (
              <SwiperSlide key={banner.id}>
                {({ isActive }) => {
                  if (isActive) {
                    sendEvent(EventType.BannerS, { bid: banner.id, name: banner.name })
                  }
                  return (
                    <div className={s.Banner}>
                      <Href
                        href={banner.link}
                        className={s.link}
                        linkType={banner.linkType === 'link' ? 'search' : 'pathname'}
                        target={banner.linkType === 'link' ? '_blank' : '_self'}
                        onClick={() => handleClick(banner)}
                      >
                        <img
                          src={isMobile ? banner.imgMobile : isTablet ? banner.imgTablet : banner.imgDesktop}
                          className={s.bannerImg}
                          loading="lazy"
                        />
                      </Href>
                    </div>
                  )
                }}
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={s.paginationWrapper}>
            <div className={s.pagination}>
              {banners.map((_, index) => (
                <span key={index} className={`${s.indicator} ${currentIndex === index ? s.indicatorActive : ''}`} />
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className={s.Banner}>
          <Href
            href={currentBanner.link}
            className={s.link}
            linkType={currentBanner.linkType === 'link' ? 'search' : 'pathname'}
            target={currentBanner.linkType === 'link' ? '_blank' : '_self'}
            onClick={() => handleClick(currentBanner)}
          >
            <img src={bannerImg} className={s.bannerImg} />
          </Href>
          <button
            onClick={() => setCurrentIndex((prev) => (prev - 1 + banners.length) % banners.length)}
            className={`${s.sliderButton} ${s.sliderButtonPrev}`}
          >
            <ArrowIcon className={s.arrow} />
          </button>
          <button
            onClick={() => setCurrentIndex((prev) => (prev + 1) % banners.length)}
            className={`${s.sliderButton} ${s.sliderButtonNext}`}
          >
            <ArrowIcon className={s.arrow} />
          </button>
        </div>
      )}
    </section>
  )
}
